import React from 'react'

export const TiktokIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.1071 2.50667C10.4969 1.81291 10.1606 0.922133 10.1607 0H7.40179V11.0222C7.38095 11.6188 7.12814 12.1841 6.6967 12.5987C6.26526 13.0133 5.68893 13.2448 5.08929 13.2444C3.82143 13.2444 2.76786 12.2133 2.76786 10.9333C2.76786 9.40444 4.25 8.25778 5.77679 8.72889V5.92C2.69643 5.51111 0 7.89333 0 10.9333C0 13.8933 2.46429 16 5.08036 16C7.88393 16 10.1607 13.7333 10.1607 10.9333V5.34222C11.2795 6.14209 12.6226 6.57124 14 6.56889V3.82222C14 3.82222 12.3214 3.90222 11.1071 2.50667Z"
      fill="currentColor"
    />
  </svg>
)
